module.exports = __webpack_public_path__ + "img/8.24ab7a98.jpg";